import React, {useState} from "react"
import {connect} from "@irati/store"
import authentication from "@irati/auth"
import {isNewRecognition} from "@irati/recognition/utils/polls/isNew"
import {FormattedRelative} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {TextButton} from "@irati/ui/src/Button"
import {RECOGNITION} from "@irati/recognition/constants/feedTypes"
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList"
import {Recognition, RecognitionFeed} from "@irati/types"
import RecognitionHubViews from "@irati/recognition/constants/hubViewTypes"
import {FeedItem} from "../../Feed"
import {getRecognitionPath} from "../../../utils/paths"
import {RouterLink} from "../../shared"
import WhoCreated from "../../WhoCreated"
import ProfilePicGroup, {OUTER_WRAPPER_SIZE, SINGLE_PICTURE_SIZE, MULTIPLE_PICTURE_SIZE} from "../../ProfilePicGroup"
import {Activity as IconsActivity} from "../../Icons"
import {AddReaction} from "../../Reactions"
import ModeratedMessage from "../../shared/Moderated"
import OccasionIcon from "../../shared/OccasionIcon"
import Details from "../../Details"
import BodyWrapper from "../../shared/BodyWrapper"
import {IconsRow, FlexRow, BodyContainer} from "./styled"
import {Recognition as RecognitionTitle} from "./Titles"
import {EndDate, StyledBody} from "./styled/Card"
import Confetti from "./Confetti"

interface FeedRecognitionProps {
  item: RecognitionFeed
  className: string
  onClick: (item: Recognition) => void
  isMobile: boolean
  id: string
}
const FeedRecognition: React.FC<FeedRecognitionProps> = (props) => {
  const {item, className, onClick, isMobile, id: feedItemId = "closed-recognition"} = props
  const {recognition} = item
  const [showEmojiPicker, setShowEmojiPicker] = useState(false)
  const togglePickerModal = () => setShowEmojiPicker(!showEmojiPicker)

  const handleClick = () => onClick(recognition)

  const getButtonProps = () => {
    return {
      inline: false,
      onClick: handleClick,
      id: id("btn", props)
    }
  }

  const getLinkProps = () => ({
    to: getRecognitionPath(recognition),
    scrollToTop: false,
    plain: true
  })

  const users = recognition.receivers!.results
  const user = authentication.user()
  const isNew = isNewRecognition(recognition)
  const isWinner = users.map(({uuid}) => uuid).includes(user.uuid)

  const hasClickCallback = typeof onClick === "function"
  const Button = hasClickCallback ? TextButton : RouterLink
  const btnProps = hasClickCallback ? getButtonProps() : getLinkProps()
  return (
    <Button {...btnProps}>
      {showEmojiPicker && <AddReaction feedItem item={recognition} togglePickerModal={togglePickerModal} />}
      <FeedItem className={className} isNew={isNew}>
        {isNew && isWinner && <Confetti />}
        <FlexRow isPrivate={recognition.private}>
          <ProfilePicGroup
            users={users}
            outerWrapperSize={OUTER_WRAPPER_SIZE(isMobile)}
            singlePictureSize={SINGLE_PICTURE_SIZE(isMobile)}
            multiplePictureSize={MULTIPLE_PICTURE_SIZE(isMobile)}
          />
          <BodyWrapper>
            <BodyContainer>
              <RecognitionTitle recognition={recognition} />
              <IconsRow>
                <OccasionIcon occasion={recognition.occasion} />
                <CompanyValues companyValues={recognition.companyValues} limit={1} />
              </IconsRow>
              <Details recognition={recognition} />
              <EndDate>
                <FormattedRelative value={recognition.createdAt} />
              </EndDate>
              <StyledBody small marginBottom={1}>
                <ModeratedMessage message={recognition.message} isModerated={recognition.moderated} />
              </StyledBody>
              <WhoCreated createdBy={recognition.createdBy} />
              <IconsActivity
                viewType={RecognitionHubViews.CARD_VIEW}
                feedItemId={feedItemId}
                item={recognition}
                type={RECOGNITION}
                togglePickerModal={togglePickerModal}
              />
            </BodyContainer>
          </BodyWrapper>
        </FlexRow>
      </FeedItem>
    </Button>
  )
}

const mapStateToProps = ({mq}) => {
  return {
    isMobile: mq.lessThan.md
  }
}

export default connect(mapStateToProps)(FeedRecognition)
